import {
	Modal,
} from 'react-bootstrap';
import Button, {
	ButtonColor,
} from 'components/button';
import './parkingLotSelector.scss';
import {
	useState,
} from 'react';

const definedParkingLots: {[key: string]: string[]} = {
	'default': [
		'A1', 'A2', 'A3', 'A4',
		'B1', 'B2', 'B3', 'B4',
		'C1', 'C2', 'C3', 'C4',
		'D1', 'D2', 'D3', 'D4',
	],
	'7080004186095': [ // Horten
		'A1', 'A2', 'A3', 'A4',
		'B1', 'B2', 'B3', 'B4',
		'C1', 'C2', 'C3', 'C4',
		'D1', 'D2', 'D3', 'D4',
		'E1', 'E2', 'E3', 'E4', 'E5', 'E6', 'E7',
		'F1', 'F2', 'F3',
	],
	'7080004186101': [ // Moss
		'A1', 'A2', 'A3', 'A4',
		'B1', 'B2', 'B3', 'B4',
		'C1', 'C2', 'C3', 'C4',
		'D1', 'D2', 'D3', 'D4',
		'E1', 'E2', 'E3', 'E4',
		'F1', 'F2', 'F3', 'F4',
		'G1', 'G2', 'G3', 'G4', 'G5', 'G6',
		'H1', 'H2', 'H3', 'H4', 'H5', 'H6',
	],
};

interface ParkingLotSelectorProps {
  /**
   * The name of the current lot, if any
   */
  currentLot: string,

	/**
	 * GLN of the location
	 */
	location?: string,

  /**
   * Function which should be called when a new lot has been chosen
   */
  onChange: (lot: string) => void,

  /**
   * Whether to show or hide the modal
   */
	show: boolean,

  /**
   * The function to be called for toggling show state
   */
  setShow: (show: boolean) => void,
}

const ParkingLotSelector = ({
	currentLot,
	location = 'default',
	onChange,
	show,
	setShow,
}: ParkingLotSelectorProps) => {
	const [newLot, setNewLot] = useState<string>(currentLot);

	const handleClose = () => setShow(false);
	// const handleShow = () => setShow(true);

	const onSelect = (e: any) => {
		setNewLot(e.target.value);
	};

	const handleChange = (_e: any) => {
		if (currentLot !== newLot) {
			onChange(newLot);
		}

		handleClose();
	};

	return (
		<Modal show={show}>
			<Modal.Header className="parking-lot-modal-header-adjustments" />
			<Modal.Body>
				<div className="parking-lot-selector-container">
					<div>
						<h5 className="parking-lot-selector-title">Bytt til ledig parkeringplass</h5>
					</div>

					<div>
						<div className="parking-lot-selector-grid" onChange={onSelect}>
							{(definedParkingLots[location] || definedParkingLots['default']).map((lot: string) => {
								const name = 'parking_lot';
								const id = 'parking_lot_'.concat(lot);

								return (
									<div key={id}>
										<input type="radio" name={name} id={id} value={lot} defaultChecked={currentLot === lot} />
										<label htmlFor={id}>
											&nbsp;{lot}
										</label>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</Modal.Body>
			<Modal.Footer className="parking-lot-modal-footer-adjustments">
				<Button color={ButtonColor.SECONDARY} onClick={handleClose}>Avbryt</Button>
				<Button color={ButtonColor.PRIMARY} onClick={handleChange} disabled={currentLot === newLot}>Bekreft</Button>
			</Modal.Footer>
		</Modal>
	);
}

export default ParkingLotSelector;